module.exports = __webpack_public_path__ + "img/jobs.cb81c198.svg";